export default {
  country_locale: 'sk-SK',
  wia_title: 'Webová online pomoc',
  wia_need_help: 'Potrebujem pomôcť s',
  wia_model_name: 'Model spotrebiča je',
  wia_back: '< zmeniť',
  wia_confirm: 'Potvrdiť',
  wia_issue_title: 'Aký máte problém?',
  wia_issue_concern: 'Môj problém sa týka',
  wia_issue_specific: 'Špecifikujte problém',
  wia_possible_solution: 'Možná riešenia',
  wia_solved_issue: 'Vyriešilo to problém?',
  wia_closed: 'Zatvoriť X',
  wia_feedback_ok: 'Áno!',
  wia_find_another_solution: 'Nájsť iné riešenie',
  wia_feedback_title: 'Sme radi, že sa podarilo problém vyriešiť!',
  wia_feedback_text1: 'Navštívte náš obchod so špeciálnymi ponukami práve pre vás',
  wia_feedback_text2: 'Zistite viac o našich najnovších, chytrých technológiách',
  wia_smile_up_popup_text1: 'Objavte naše plány ochrany',
  wia_smile_down_popup_title: 'Ospravedlňujeme sa',
  wia_smile_down_popup_text1: 'Prejdite na druhý krok',
  wia_smile_down_popup_or_text: 'or',
  wia_smile_down_popup_text2: 'Prejdite na stránku kontaktov',
  wia_need_more_help: 'Potrebujete ďaľšiu pomoc ?',
  wia_optional_label: '(voliteľné)',
  wia_no_solution: 'Je nám ľúto, ale nenašli sme pre vás riešenie online. Prosím kliknite tu na ďaľšiu podporu',
  wia_all_solution: 'Všetky výsledky',
  wia_all_categories: 'Všetky kategórie',
  wia_seo_l1_issue: 'Všetky chyby podľa kategórií',
  wia_seo_wp_country_name: '',
  wia_seo_bk_country_name: '',
  wia_seo_hp_country_name: '',
  wia_seo_id_country_name: 'SK',
  wia_seo_wp_meta_title: 'Problémy a riešenia',
  wia_seo_bk_meta_title: 'Problémy a riešenia',
  wia_seo_hp_meta_title: 'Problémy a riešenia',
  wia_seo_id_meta_title: 'Problémy a riešenia',
  wia_seo_wp_meta_description: 'Vyriešte problémy s vašim výrobkom iba niekoľkými klikmi za pomoci našej online technickej asistencie Whirlpool Slovensko',
  wia_seo_bk_meta_description: 'Vyriešte problémy s vašim výrobkom iba niekoľkými klikmi za pomoci našej online technickej asistencie Bauknecht Slovensko',
  wia_seo_hp_meta_description: 'Vyriešte problémy s vašim výrobkom iba niekoľkými klikmi za pomoci našej online technickej asistencie Hotpoint Slovensko',
  wia_seo_id_meta_description: 'Vyriešte problémy s vašim výrobkom iba niekoľkými klikmi za pomoci našej online technickej asistencie Indesit Slovensko',
  wia_seo_wp_meta_description_home: '',
  wia_seo_bk_meta_description_home: '',
  wia_seo_hp_meta_description_home: '',
  wia_seo_id_meta_description_home: ''
}
